// extracted by mini-css-extract-plugin
module.exports = {"container":"SurveyFormDetails_container__2Iii4","header":"SurveyFormDetails_header__1nPiO","headerLoading":"SurveyFormDetails_headerLoading__2Mjrm"};